import { render } from "./FichaSaude.vue?vue&type=template&id=3d35b252&scoped=true"
import script from "./FichaSaude.vue?vue&type=script&lang=js"
export * from "./FichaSaude.vue?vue&type=script&lang=js"

import "./FichaSaude.vue?vue&type=style&index=0&id=3d35b252&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d35b252"]])

export default __exports__